import request from '@/common/js/request.js'

export function fetchRecommendOrgan (isRecommend , pageSize, pageNo , isOpen , isApprove) {
  // const url = '/orginfo/page'
  const url = '/Org/getOrgListByConditionForMobile'
  const data = Object.assign({}, {
    isRecommend: isRecommend + '',
    pageSize: pageSize + '',
    pageNo: pageNo + '',
    isOpen: isOpen + '',
    isApprove: isApprove + ''
    // orgName: name || ''
  })
  return request({
    url: url,
    method: 'get',
    params: data
  })
}

export function getOrganList (obj) {
  // const url = '/orginfo/page'
  const url = '/Org/getOrgListByConditionForMobile'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}

export function getRecommendComment (obj) {
  const url = '/courseComment/getCourseCommentListByCondition'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}

export function getOrganType (obj) {
  // const url = '/orgType/getOrgTypeNameAndId'
  const url = '/orgType/getOrgTypeListForMobile'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}

export function getTeacherByOrg (obj) {
  const url = '/user/getTeacherByOrgInfoId'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}

//查机构信息
export function getOrganxx (obj) {
  // const url = '/orginfo/page'
  const url = '/Org/getOrgInfoByIdForWeb'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}


//查机构详情信息
export function getOrganinfo (obj) {
  const url = '/Org/getOrgInfoByCondition'
  return request({
    url: url,
    method: 'get',
    params: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/organ.js